import { render, staticRenderFns } from "./BarGraph.vue?vue&type=template&id=4a00a6ce&scoped=true&"
import script from "./BarGraph.vue?vue&type=script&lang=js&"
export * from "./BarGraph.vue?vue&type=script&lang=js&"
import style0 from "./BarGraph.vue?vue&type=style&index=0&id=4a00a6ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00a6ce",
  null
  
)

export default component.exports